import { convertToUtcDate, getDefaultWeekStartDate, getUtcEndOfWeekDate } from '@townsquare/date-utils/update';
import { getCurrentGoalMonthRange } from '@townsquare/goal-update-composer/date';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator, FilterDoc, Input, Join, Operators, SupportedFiltersTypes } from '@townsquare/tql/types';

export const getPendingUpdateProjectsTqlQuery = (
  accountId: string,
  showPendingAndPaused: boolean,
  showContributing: boolean,
) => {
  const doc: FilterDoc = {
    model: [
      {
        model: showPendingAndPaused ? ['pending', 'in_progress', 'paused'] : ['in_progress'],
        comparator: ComparatorOperator.EQUALS,
        operator: Operators.OR,
        type: SupportedFiltersTypes.PROJECT_STATUS,
      },
    ],
    operator: Operators.AND,
  };

  const tqlInput: (Input | Join)[] = [
    { fieldName: 'owner', fieldValue: accountId, comparator: ComparatorOperator.EQUALS },
  ];
  if (showContributing) {
    tqlInput.push(
      { join: Operators.OR },
      {
        fieldName: 'contributor',
        fieldValue: accountId,
        comparator: ComparatorOperator.EQUALS,
      },
    );
  }
  tqlInput.push(
    { join: Operators.AND },
    { fieldName: 'archived', fieldValue: false, comparator: ComparatorOperator.EQUALS },
  );

  return tqlQueryFromInput({
    input: tqlInput,
    doc: doc,
  });
};

export const getPendingUpdateGoalsTqlQuery = (accountId: string, showPendingAndPaused: boolean) => {
  const doc: FilterDoc = {
    model: [
      {
        model: showPendingAndPaused ? ['pending', 'in_progress', 'paused'] : ['in_progress'],
        comparator: ComparatorOperator.EQUALS,
        operator: Operators.OR,
        type: SupportedFiltersTypes.GOAL_STATUS,
      },
    ],
    operator: Operators.AND,
  };

  return tqlQueryFromInput({
    input: [
      { fieldName: 'owner', fieldValue: accountId, comparator: ComparatorOperator.EQUALS },
      { join: Operators.AND },
      { fieldName: 'archived', fieldValue: false, comparator: ComparatorOperator.EQUALS },
    ],
    doc: doc,
  });
};

export const isProjectUpdatedThisWeek = (projectUpdateCreationDate?: string | null) => {
  return !!(
    projectUpdateCreationDate &&
    new Date(convertToUtcDate(projectUpdateCreationDate)) > getUtcEndOfWeekDate(getDefaultWeekStartDate())
  );
};

export const isGoalUpdatedThisMonth = (goalUpdateCreationDate?: string | null) => {
  const { startOfGoalMonthDate } = getCurrentGoalMonthRange();
  return !!(goalUpdateCreationDate && new Date(convertToUtcDate(goalUpdateCreationDate)) > startOfGoalMonthDate);
};
